"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Separator } from "@/components/ui/separator";
import { MapPin, Phone, Mail } from "lucide-react";
const serviceAreas = ["Downtown", "Midtown", "West End", "Waterfront", "The Annex", "Yorkville", "Liberty Village", "Distillery", "Leslieville", "High Park", "Rosedale", "The Beaches", "North York"];
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="space-y-3">
        {[1, 2, 3, 4, 5].map((_, i) => <li key={i} data-index={i}>
            <div className="h-4 w-24 bg-foreground/10 animate-pulse rounded-md" />
          </li>)}
      </ul>;
  }
  return <ul className="space-y-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-foreground/60 hover:text-primary transition-colors text-sm font-default">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function Footer() {
  return <section data-section-id="264800" id="footer" className="bg-background text-foreground pt-16 pb-8 border-t-8 border-primary">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8 mb-12">
          
          {}
          <div className="flex flex-col gap-6">
            <Link to="/" className="inline-block w-fit">
              <WvcLogo className="h-8 w-auto text-primary" />
            </Link>
            <p className="text-foreground/60 text-sm leading-relaxed max-w-xs font-default">
              Urban Living Rentals redefines the modern apartment search. We curate premium living spaces in the city's most vibrant neighborhoods, blending architectural elegance with high-end hospitality.
            </p>
          </div>

          {}
          <div>
            <h3 className="font-default font-bold text-lg mb-6 tracking-tight">Explore</h3>
            <MenuProvider menu_id="65">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div>
            <h3 className="font-default font-bold text-lg mb-6 tracking-tight">Prime Locations</h3>
            <div className="grid grid-cols-3 sm:grid-cols-4 lg:grid-cols-3 gap-2">
              {serviceAreas.map((area, i) => <div key={area} data-index={i} className="text-foreground/60 text-xs py-1 px-2 bg-foreground/5 rounded-md text-center border border-border hover:border-primary/30 transition-colors font-default">
                  {area}
                </div>)}
            </div>
          </div>

          {}
          <div>
            <h3 className="font-default font-bold text-lg mb-6 tracking-tight">Get In Touch</h3>
            <ul className="space-y-4">
              <li data-index={0}>
                <Link to="tel:4165550198" className="flex items-start gap-3 text-foreground/60 hover:text-primary transition-colors group">
                  <Phone className="size-5 shrink-0 mt-0.5 text-primary group-hover:text-primary/80 transition-colors" />
                  <span className="text-sm font-default">(416) 555-0198</span>
                </Link>
              </li>
              <li data-index={1}>
                <Link to="mailto:concierge@urbanlivingrentals.com" className="flex items-start gap-3 text-foreground/60 hover:text-primary transition-colors group">
                  <Mail className="size-5 shrink-0 mt-0.5 text-primary group-hover:text-primary/80 transition-colors" />
                  <span className="text-sm break-all font-default">concierge@urbanlivingrentals.com</span>
                </Link>
              </li>
              <li data-index={2} className="flex items-start gap-3 text-foreground/60">
                <MapPin className="size-5 shrink-0 mt-0.5 text-primary" />
                <span className="text-sm font-default">100 Queen Street West,<br />Toronto, ON M5H 2N2</span>
              </li>
            </ul>
          </div>

        </div>

        <Separator className="bg-border mb-8" />

        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-foreground/40 text-sm font-default">
          <p>© {new Date().getFullYear()} Urban Living Rentals. Curated Architectural Living.</p>
          <div className="flex gap-4">
            <Link to="#" className="hover:text-primary transition-colors">Privacy Policy</Link>
            <Link to="#" className="hover:text-primary transition-colors">Terms of Service</Link>
          </div>
        </div>
      </div>
    </section>;
}